// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__1vXpe","tooltip":"Tooltip_tooltip__MMI2v","arrow":"Tooltip_arrow__iUFNC","content":"Tooltip_content__I56yX"};